import { IFilterSet, isDateRangeFilter, deserializeDateRange } from '../typings'
import {
  singleToMultiSelectFields,
  transformSelectSingleToMultiValues,
} from './transformSelectSingleToMultiValues'

export function deserializeFilters<U, T extends IFilterSet<U>>(
  defaultValues: T,
  json: string,
): T {
  const parsed = JSON.parse(json)

  const orderBy = parsed.orderBy ?? defaultValues.orderBy

  const parsedFilters = parsed.filters ?? {}
  const filters = Object.keys(defaultValues.filters).reduce<T['filters']>(
    (prev, k) => {
      if (!!parsedFilters[k] && !!parsedFilters[k].value) {
        const filter = prev[k]
        if (isDateRangeFilter(filter)) {
          const dateRange = deserializeDateRange(parsedFilters[k].value)
          return { ...prev, [k]: { ...filter, value: dateRange } }
        }

        if (singleToMultiSelectFields.includes(k)) {
          return transformSelectSingleToMultiValues<U, T>(
            parsedFilters,
            k,
            prev,
            filter,
          )
        }

        return {
          ...prev,
          [k]: {
            ...filter,
            value: parsedFilters[k].value,
          },
        }
      }
      return prev
    },
    { ...defaultValues.filters },
  )

  return { ...defaultValues, filters, orderBy }
}
